import { NotifyHelper } from "../../../helpers/toast";
import { eSaleSetActionTypeDefine } from "../../action-types/sale-set/ISaleSetActionType";
import { generateActionForKey, generateActions } from "../generateActions";

export const saleSetActions = {
    ...generateActions(eSaleSetActionTypeDefine, "SALE_SET"),
    ...generateActionForKey(eSaleSetActionTypeDefine, "SALE_SET", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eSaleSetActionTypeDefine, "SALE_SET", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eSaleSetActionTypeDefine, "SALE_SET", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eSaleSetActionTypeDefine, "SALE_SET", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eSaleSetActionTypeDefine, "SALE_SET", "LOAD_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eSaleSetActionTypeDefine, "SALE_SET", "LOAD_BY_HOCSINH_ERROR", (m) => { NotifyHelper.Error(m) })
};
